module.exports = __webpack_public_path__ + "static/media/gk-tiramisu-solo.986d7342.png";